export default __webpack_public_path__ + "static/banner2-3745827ee5f94ad896d4a1f8d5d9121b.jpg";